<div class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-slate-900/60 backdrop-blur-sm" (click)="onClose()">
  <div class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col h-[min(92vh,880px)]"
    (click)="$event.stopPropagation()">

    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <ng-container *ngIf="detail as d">
      <!-- Header -->
      <div class="flex-none px-5 md:px-8 py-4 border-b border-slate-100 dark:border-slate-800">
        <div class="flex items-start justify-between gap-4 mb-4">
          <div class="min-w-0">
            <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 flex-wrap">
              <span class="material-icons text-amber-500">confirmation_number</span>
              <span class="truncate">{{ d.name }}</span>
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold" [ngClass]="statusBadgeClass(d.status)">
                {{ statusLabel(d.status) }}
              </span>
            </h3>
            <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">ดูข้อมูลใบคำขอแบบฟอร์ม · รหัสแยกแท็บ</p>
          </div>
          <button type="button" (click)="onClose()" [disabled]="isExporting()"
            class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors shrink-0">
            <span class="material-icons">close</span>
          </button>
        </div>

        <div class="grid grid-cols-2 gap-2">
          <button type="button" (click)="setTab('form')"
            class="rounded-xl border px-3 py-2 text-left transition-all"
            [ngClass]="activeTab() === 'form'
              ? 'border-amber-400 bg-amber-50 dark:bg-amber-950/30'
              : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900'">
            <p class="text-[11px] font-bold text-slate-400">แท็บ 1</p>
            <p class="text-xs font-extrabold text-slate-800 dark:text-slate-100">ข้อมูลใบคำขอ</p>
          </button>
          <button type="button" (click)="setTab('codes')"
            class="rounded-xl border px-3 py-2 text-left transition-all"
            [ngClass]="activeTab() === 'codes'
              ? 'border-amber-400 bg-amber-50 dark:bg-amber-950/30'
              : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900'">
            <p class="text-[11px] font-bold text-slate-400">แท็บ 2</p>
            <p class="text-xs font-extrabold text-slate-800 dark:text-slate-100">
              รหัส Activate
              <span *ngIf="isExecuted && activateCodes.length" class="font-bold text-amber-600"> ({{ activateCodes.length }})</span>
            </p>
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="flex-1 min-h-0 overflow-hidden px-5 md:px-8 py-5 flex flex-col">

        <!-- Tab: Form -->
        <div *ngIf="activeTab() === 'form'" class="flex-1 min-h-0 overflow-y-auto custom-scrollbar space-y-4">
          <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-sm text-sky-900 dark:text-sky-100">
            ดูข้อมูลเหมือนฟอร์มสร้างบัตร — แก้ไขไม่ได้จากหน้ารายละเอียดนี้
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ร้าน / Client</label>
            <div class="w-full h-[46px] flex items-center gap-2 px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-bold text-slate-800 dark:text-slate-100">
              <span class="material-icons text-slate-400 text-lg">store</span>
              <span class="truncate">{{ d.clientName || '-' }}</span>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Subscription</label>
            <div class="w-full min-h-[46px] flex items-center px-3 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-bold text-slate-800 dark:text-slate-100">
              {{ d.subscriptionName || '-' }}
            </div>
          </div>

          <div class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 text-sm">
            <div class="grid grid-cols-2 gap-3">
              <div>
                <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทบัตร</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.cardTypeName || '-' }}</div>
              </div>
              <div>
                <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทรถ</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.vehicleTypeName || '-' }}</div>
              </div>
              <div>
                <div class="text-xs text-slate-400 font-bold uppercase mb-1">ขอบเขตบัตร</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ cardScopeLabel(d.cardScope) }}</div>
              </div>
              <div>
                <div class="text-xs text-slate-400 font-bold uppercase mb-1">ชนิด Advance</div>
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ advanceKindLabel(d.advanceKind) }}</div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จำนวนรหัส</label>
              <div class="w-full h-[46px] flex items-center px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-black text-amber-600">
                {{ d.qty }}
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสใช้ได้ภายใน (วัน)</label>
              <div class="w-full h-[46px] flex items-center px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-bold text-slate-800 dark:text-slate-100">
                {{ d.activateExpireDays || 10 }}
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันเริ่ม</label>
              <div class="w-full h-[46px] flex items-center px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-bold text-slate-800 dark:text-slate-100">
                {{ d.startDate ? (d.startDate | date:'dd/MM/yyyy') : '-' }}
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันหมดอายุ</label>
              <div class="w-full h-[46px] flex items-center px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-bold text-slate-800 dark:text-slate-100">
                {{ d.endDate ? (d.endDate | date:'dd/MM/yyyy') : '-' }}
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันที่สร้าง</label>
              <div class="w-full h-[46px] flex items-center px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-bold text-slate-800 dark:text-slate-100">
                {{ d.createDate ? (d.createDate | date:'dd/MM/yyyy HH:mm') : '-' }}
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ใบเสร็จ</label>
              <div class="w-full h-[46px] flex items-center px-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-mono font-bold text-slate-800 dark:text-slate-100 truncate">
                {{ d.financeReceiptId || '-' }}
              </div>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
            <div class="w-full min-h-[72px] px-3 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm text-slate-700 dark:text-slate-200 whitespace-pre-wrap">
              {{ d.remark || '—' }}
            </div>
          </div>
        </div>

        <!-- Tab: Codes -->
        <div *ngIf="activeTab() === 'codes'" class="flex-1 min-h-0 flex flex-col gap-3">
          <ng-container *ngIf="!isExecuted">
            <div class="flex-1 flex items-center justify-center p-6 rounded-2xl border border-dashed border-amber-200 dark:border-amber-800 bg-amber-50/40 dark:bg-amber-900/10 text-center text-sm text-amber-800 dark:text-amber-300">
              <div>
                <span class="material-icons text-3xl mb-2 block text-amber-500">info</span>
                รหัส activate จะแสดงหลัง Gen Code (สถานะ "สร้างรหัสแล้ว")
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="isExecuted">
            <div class="flex-none flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div>
                <h4 class="text-sm font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                  <span class="material-icons text-base text-blue-500">qr_code</span>
                  รหัส Activate
                </h4>
                <p *ngIf="activateCodes.length > 0" class="text-xs text-slate-500 mt-1">
                  ใช้แล้ว {{ usedCodeCount }} · ยังไม่ใช้ {{ unusedCodeCount }} · รวม {{ activateCodes.length }}
                </p>
              </div>
              <button *ngIf="activateCodes.length > 0" type="button" (click)="exportExcel()" [disabled]="isExporting()"
                class="px-4 py-2 rounded-xl border border-emerald-200 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400 text-sm font-bold hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-colors disabled:opacity-50 flex items-center gap-2 self-start">
                <span class="material-icons text-base">download</span>
                Export Excel
              </button>
            </div>

            <div *ngIf="isLoadingCodes()"
              class="flex-none p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center gap-3 text-sm text-slate-500">
              <div class="w-5 h-5 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
              กำลังโหลดรหัส activate...
            </div>

            <ng-container *ngIf="!isLoadingCodes()">
              <div *ngIf="activateCodes.length === 0"
                class="flex-1 flex items-center justify-center p-8 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 text-slate-400 text-sm">
                ไม่พบรหัส activate
              </div>

              <ng-container *ngIf="activateCodes.length > 0">
                <div class="flex-none flex flex-wrap gap-2">
                  <button type="button" (click)="setCodeFilter('all')"
                    class="px-3 py-1.5 rounded-lg text-xs font-bold border transition-colors"
                    [ngClass]="codeFilter === 'all'
                      ? 'border-amber-400 bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200'
                      : 'border-slate-200 dark:border-slate-700 text-slate-500'">
                    ทั้งหมด ({{ activateCodes.length }})
                  </button>
                  <button type="button" (click)="setCodeFilter('unused')"
                    class="px-3 py-1.5 rounded-lg text-xs font-bold border transition-colors"
                    [ngClass]="codeFilter === 'unused'
                      ? 'border-emerald-400 bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200'
                      : 'border-slate-200 dark:border-slate-700 text-slate-500'">
                    ยังไม่ใช้ ({{ unusedCodeCount }})
                  </button>
                  <button type="button" (click)="setCodeFilter('used')"
                    class="px-3 py-1.5 rounded-lg text-xs font-bold border transition-colors"
                    [ngClass]="codeFilter === 'used'
                      ? 'border-slate-400 bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200'
                      : 'border-slate-200 dark:border-slate-700 text-slate-500'">
                    ใช้แล้ว ({{ usedCodeCount }})
                  </button>
                </div>

                <div class="flex-none relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg pointer-events-none">search</span>
                  <input type="text" [(ngModel)]="codeSearch" placeholder="ค้นหารหัส..."
                    class="w-full h-[42px] pl-10 pr-4 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-mono outline-none focus:ring-2 focus:ring-amber-200" />
                </div>

                <p class="flex-none text-[11px] text-slate-400">แสดง {{ filteredCodes.length }} รายการ</p>

                <div class="flex-1 min-h-0 overflow-y-auto rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/40 dark:bg-slate-800/30 custom-scrollbar">
                  <div *ngFor="let code of filteredCodes; let i = index"
                    class="px-3 py-2.5 border-b border-slate-100 dark:border-slate-800 last:border-b-0 flex items-start gap-3 hover:bg-white/80 dark:hover:bg-slate-800/60">
                    <span class="text-[11px] font-mono text-slate-400 w-7 shrink-0 pt-0.5">{{ i + 1 }}</span>
                    <div class="min-w-0 flex-1">
                      <div class="flex items-center gap-2 flex-wrap">
                        <span class="font-mono font-bold text-sm text-slate-800 dark:text-slate-100 tracking-wide break-all">{{ code.code }}</span>
                        <span class="inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0"
                          [ngClass]="code.isUsed
                            ? 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'
                            : 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'">
                          {{ code.isUsed ? 'ใช้แล้ว' : 'ยังไม่ใช้' }}
                        </span>
                      </div>
                      <div class="mt-1 text-[11px] text-slate-500 flex flex-wrap gap-x-3 gap-y-0.5">
                        <span>บัตร {{ code.startDate | date:'dd/MM/yy' }}–{{ code.endDate | date:'dd/MM/yy' }}</span>
                        <span>หมดรหัส {{ code.activateExpireAt ? (code.activateExpireAt | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
                        <span *ngIf="code.activateDate">Activate {{ code.activateDate | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="filteredCodes.length === 0" class="px-4 py-10 text-center text-sm text-slate-400">
                    ไม่พบรหัสที่ตรงเงื่อนไข
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex-none px-5 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3">
        <button *ngIf="activeTab() === 'form' && isExecuted" type="button" (click)="setTab('codes')"
          class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg transition-colors flex items-center justify-center gap-1">
          ดูรหัส Activate
          <span class="material-icons text-base">arrow_forward</span>
        </button>
        <button *ngIf="activeTab() === 'codes'" type="button" (click)="setTab('form')"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
          กลับไปข้อมูลใบคำขอ
        </button>
        <button type="button" (click)="onClose()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors sm:ml-auto">
          ปิด
        </button>
      </div>
    </ng-container>
  </div>
</div>
